import axios from "@/api/index";
import Cookie from "js-cookie";
import md5 from "js-md5";

//获取微信信公众号授权跳转地址
export function GetAuthUrl(data) {
  return CallApi("/api/Wxgzh/GetAuthUrl", "post", data);
}
//获取电话短信
export function SendSMSCode(data) {
  return axios({
    url: "/api/Common/SendSMSCode",
    method: "post",
    data
  });
}
//根据授权码区获取粉丝信息
export function GetAuthUserinfo(data) {
  return axios({
    url: "/api/Wxgzh/GetAuthUserinfo",
    method: "post",
    data
  });
}
//获取页面的js_ticket
export function GetPageJsticket(data) {
  return CallApi("/api/Wxgzh/GetPageJsticket", "post", data);
}
export function GetOpenid(data) {
  return axios({
    url: "/api/Wxxcx/GetOpenid",
    method: "post",
    data
  });
}
export function GetToken(data) {
  return axios({
    url: "/api/Token/GetToken",
    method: "post",
    data
  });
}
export function ValidateToken(data) {
  return axios({
    url: "/api/Token/ValidateToken",
    method: "post",
    data
  });
}

export function GetResponse(data) {
  return axios({
    url: "/api/WX/GetResponse",
    method: "post",
    data
  });
}
export function SubmitForm(data) {
  return CallApi("/api/Act/SubmitForm", "post", data);
}
export function CountMyActDraw(data) {
  return CallApi("/api/Act/CountMyActDraw", "post", data);
}

export function Operate(data) {
  GetSign("OperateAct", data);
  return CallApi("/api/Act/OperateAct", "post", data);
}
/** 获取活动 */
export function GetAct(data) {
  return axios({
    url: "/api/Act/GetAct",
    method: "post",
    data
  });
}
//获取单个活动的详情
export function GetActById(data) {
  return axios({
    url: "/api/Act/GetActById",
    method: "post",
    data
  });
}

//活动抽奖
export function DrawAward(data) {
  return CallApi("/api/Act/DrawAward", "post", data);
}
//获取单个活动模板详情
export function GetActTemplate(data) {
  return axios({
    url: "/api/Act/GetActTemplate",
    method: "post",
    data
  });
}
//活动中奖后留资
export function UpdateActAwardHisForm(data) {
  return CallApi("/api/Act/UpdateActAwardHisForm", "post", data);
}
//获取某个活动最新的祝福语
export function GetActNewestWishings(data) {
  return CallApi("/api/Act/GetActNewestWishings", "post", data);
}
//提交祝福语
export function SubmitWishing(data) {
  return CallApi("/api/Act/SubmitWishing", "post", data);
}
//生成电子海报
export function GenActPoster(data) {
  return CallApi("/api/Act/GenActPoster", "post", data);
}
//获取活动抽奖
export function GetMyActAwardList(data) {
  return CallApi("/api/Act/GetMyActAwardList", "post", data);
}

//兑换奖品
export function ExchangeActAward(data) {
  return CallApi("/api/Act/ExchangeActAward", "post", data);
}
//活动中奖后，提交我的留资信息
export function SubmitMyActAwardFormInfo(data) {
  return CallApi("/api/Act/SubmitMyActAwardFormInfo", "post", data);
}
//统计我的活动数据
export function CountMy(data) {
  return CallApi("/api/Act/CountMy", "post", data);
}
//活动签到
export function Signin(data) {
  return CallApi("/api/Act/Signin", "post", data);
}
//答题正确后获取拼图
export function GivePuzzle(data) {
  GetSign("GivePuzzle", data);
  return CallApi("/api/Act/GivePuzzle", "post", data);
}
//用户通过分享活动，本次签到，重新获得一次答题的机会
export function ResetActSigninAnswer(data) {
  return CallApi("/api/Act/ResetActSigninAnswer", "post", data);
}
//进入活动后，提交我的留资信息
export function SubmitMyActFormInfo(data) {
  return CallApi("/api/Act/SubmitMyActFormInfo", "post", data);
}
//生成电子海报2
export function GenActPoster2(data) {
  return CallApi("/api/Act/GenActPoster2", "post", data);
}
//提交我的得分信息
export function SubmitActScore(data) {
  GetSign("SubmitActScore", data);
  return CallApi("/api/Act/SubmitActScore", "post", data);
}
//获取活动的得分榜单
export function GetActScoreList(data) {
  return CallApi("/api/Act/GetActScoreList", "post", data);
}
export function ExchangeAwardByAdmin(data) {
  GetSign("ExchangeAwardByAdmin", data);
  return CallApi("/api/Act/ExchangeAwardByAdmin", "post", data);
}

//计算签名
function GetSign(type, postData) {
  let dataValue = Date.parse(new Date()) / 1000;
  postData.zySign = "";
  postData.Timestamp = dataValue;
  postData.Nonce = dataValue;
  let PropertyNamesKeys = [
    "CallAppId=" + process.env.redstar_call_app_id,
    "Nonce=" + dataValue,
    "Timestamp=" + dataValue
  ];
  let Names = [];
  switch (type) {
    case "OperateAct":
      Names = [
        "ActId",
        "OpType",
        "ParentUid",
        "SourceUid",
        "R1",
        "R2",
        "R3",
        "R4",
        "R5"
      ];
      break;
    case "SubmitActScore":
      Names = ["ActId", "Score", "ScoreRefId", "NeedGivePuzzle"];
      break;
    case "ExchangeAwardByAdmin":
      Names = ["ActId", "ExchangePass", "ExchangeCode"];
      break;
    case "GivePuzzle":
      Names = ["ActId", "GiveType", "GiveSourceId", "GiveCount", "IsFail"];
      break;
  }
  for (let j = 0; j < Names.length; j++) {
    if (
      postData[Names[j]] ||
      postData[Names[j]] === 0 ||
      postData[Names[j]] === "0"
    ) {
      PropertyNamesKeys.push(`${Names[j]}=` + postData[Names[j]]);
    }
  }
  PropertyNamesKeys = PropertyNamesKeys.sort();
  let md5Value = "";
  PropertyNamesKeys.forEach((row, index) => {
    if (index == 0) {
      md5Value = row;
    } else {
      md5Value = md5Value + "&" + row;
    }
  });

  postData.zySign = md5(
    md5Value + "&call_app_secret=" + process.env.call_app_secret
  );
  if (Names.length == 0) {
    //走老签名
    postData.zySign = "";
  }
  return postData;
}
function CallApi(apiUrl, apiMethod, apiData) {
  return new Promise((resolve, reject) => {
    return new Promise((resolvechild, reject) => {
      axios({
        url: apiUrl,
        method: apiMethod,
        data: apiData
      }).then(res1 => {
        if (
          res1.Code == "10109" ||
          res1.Code == "10103" ||
          res1.Code == "10101" ||
          res1.Code == "10102"
        ) {
          let User = localStorage.getItem("wx_mp");
          let Headimgurl = "";
          let Nickname = "";
          if (User) {
            Headimgurl = JSON.parse(User).Headimgurl;
            Nickname = JSON.parse(User).Nickname;
          }
          let tokenData = {
            AccountType: 1,
            AccountID: process.env.Appid,
            Openid: localStorage.getItem("wx_openid"),
            Headimgurl: Headimgurl,
            Nickname: Nickname
          };
          axios({
            url: "/api/Token/GetToken",
            method: "post",
            data: tokenData
          }).then(res2 => {
            if (res2.Code == 200) {
              localStorage.setItem("wx_token", res2.DataMap.Token);
              Cookie.set("CookieToken", res2.DataMap.Token);
              localStorage.setItem("wx_mp", JSON.stringify(res2.DataMap.User));
              axios({
                url: apiUrl,
                method: apiMethod,
                data: apiData
              }).then(res3 => {
                resolve(res3);
              });
            } else {
              resolve("");
            }
          });
        } else {
          resolve(res1);
        }
      });
    }).then(res => {
      // then2
    });
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js